import * as yup from 'yup';

function name(formatMessage, getApiUrl, get) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'EDITFORM_NAME_FIELD_IS_REQUIRED',
        defaultMessage: 'Name is required',
      }),
    )
    .max(
      200,
      formatMessage({
        id: 'EDITFORM_NAME_FIELD_MAX_CHARS_200',
        defaultMessage: 'Name should be less than 200 chars',
      }),
    )
    .test(
      'unique-name',
      formatMessage({
        id: 'EDITFORM_NAME_FIELD_MUST_BE_UNIQUE',
        defaultMessage: 'Name must be unique',
      }),
      async function uniqueName(value) {
        if (this?.options?.context?.name === value) return true;
        if (!value) return true;
        try {
          const response = await get(
            `${getApiUrl()}/sxcl/v1/rules?name=${value}`,
          );
          if (response?.ok) {
            return !(response?.data?.data?.length > 0);
          }
          throw new Error('name');
        } catch (e) {
          return this.createError({
            message: formatMessage({
              id: 'EDITFORM_NAME_FIELD_UNIQUE_CHECK_FAILED',
              defaultMessage:
                'Could not validate uniqueness. Please try again.',
            }),
          });
        }
      },
    );
}

function conditions(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'EDITFORM_CONDITIONS_FIELD_IS_REQUIRED',
      defaultMessage: 'Conditions is required',
    }),
  );
}

function outcome(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'EDITFORM_OUTCOME_FIELD_IS_REQUIRED',
      defaultMessage: 'Outcome is required',
    }),
  );
}

function isActive(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'EDITFORM_ISACTIVE_FIELD_IS_REQUIRED',
      defaultMessage: 'Is Active is required',
    }),
  );
}

const validationSchema = (formatMessage, getApiUrl, get) =>
  yup
    .object({
      name: name(formatMessage, getApiUrl, get),
      conditions: conditions(formatMessage),
      outcome: outcome(formatMessage),
      isActive: isActive(formatMessage),
    })
    .required();

export default validationSchema;
